'use client';

const trustItems = [
  {
    title: 'Conformidade com o RGPD',
    description: 'Todos os dados são tratados em conformidade com o Regulamento Geral de Proteção de Dados e a legislação portuguesa aplicável.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        <polyline points="9 12 11 14 15 10"/>
      </svg>
    ),
  },
  {
    title: 'Especialistas em Setor Público',
    description: 'Equipa com experiência exclusiva em autarquias portuguesas, com conhecimento aprofundado da legislação e dos desafios do setor.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
  },
  {
    title: 'Metodologia Reconhecida',
    description: 'Diagnóstico baseado em metodologias alinhadas com as boas práticas da administração local portuguesa e orientações da DGAL.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <polyline points="9 15 11 17 15 13"/>
      </svg>
    ),
  },
  {
    title: 'Acompanhamento Pós-Diagnóstico',
    description: 'Após a receção dos resultados, a nossa equipa está disponível para esclarecer dúvidas e apoiar na implementação das recomendações.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
      </svg>
    ),
  },
];

const TrustSection = () => {
  return (
    <section className="py-16 lg:py-20" style={{ backgroundColor: '#272727' }}>
      <div className="max-w-6xl mx-auto px-6">
        {/* Section header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-8" style={{ backgroundColor: '#009688' }} />
            <span
              style={{
                fontFamily: 'DM Sans, sans-serif',
                fontSize: '0.72rem',
                fontWeight: 600,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                color: '#009688',
              }}
            >
              Porquê a GestPub
            </span>
          </div>
          <h2
            className="text-white mb-4"
            style={{ fontFamily: 'DM Sans, sans-serif', fontWeight: 700, maxWidth: '36ch' }}
          >
            Credibilidade e rigor ao serviço das autarquias
          </h2>
          <p
            className="text-base leading-relaxed"
            style={{ maxWidth: '52ch', fontFamily: 'DM Sans, sans-serif', color: 'rgba(255,255,255,0.7)' }}
          >
            Somos especialistas dedicados exclusivamente à gestão municipal portuguesa,
            com um histórial comprovado de resultados concretos.
          </p>
        </div>

        <div
          className="grid md:grid-cols-2 gap-px"
          style={{ backgroundColor: 'rgba(255,255,255,0.08)' }}
        >
          {trustItems?.map((item) => (
            <div
              key={item?.title}
              className="flex gap-5 p-8 transition-colors duration-200 hover:bg-[#2E2E2E]"
              style={{ backgroundColor: '#272727' }}
            >
              <div
                className="flex-shrink-0 w-10 h-10 flex items-center justify-center"
                style={{ borderRadius: '5px', border: '1px solid rgba(255,255,255,0.15)', color: '#009688' }}
              >
                {item?.icon}
              </div>
              <div>
                <h4
                  className="text-white font-semibold mb-2"
                  style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '1.05rem', fontWeight: 700 }}
                >
                  {item?.title}
                </h4>
                <p
                  className="text-sm leading-relaxed"
                  style={{ fontFamily: 'DM Sans, sans-serif', color: 'rgba(255,255,255,0.65)' }}
                >
                  {item?.description}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TrustSection;